<div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
        <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div>
<div class="container-fluid" style="margin-top:20px;" >
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between">
                <h4 class="font-weight-bold text-dark py">COURSE</h4>
                <div style="width:120px">
                    <button type="button" class="btn btn-block btn-primary" data-toggle="modal" data-target="#myModal"
                        (click)="setCurrentdate()">Add</button>
                </div>
            </div>

        </div>
        <div *ngIf="!tableshow" class="d-flex justify-content-center">
            <div class="loader"></div>
        </div>
        <div class="p-3">
            <div class="table-responsive" *ngIf="tableshow">
                <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%"
                    cellspacing="0">
                    <thead>
                        <tr>
                            <th>Course Name</th>
                            <th>Description</th>
                            <th>No.Of  Days</th>
                            <th>No.Of Hours </th>
                            <!-- <th>Scheme</th>
                            <th>Category</th> -->
                            <th>Show</th>
                            <th>Edit</th>
                            <th>Delete</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let customer of customers">
                            <td style="min-width: 20px;">
                                {{customer.course_name}}
                            </td>
                            <!-- <td style="min-width: 20px;">
                            {{customer.designation}}
                            </td> -->
                            <!-- <td style="min-width: 20px;">
                            {{customer.applied_role}}
                            </td> -->
                            <!-- <td style="min-width: 20px;">
                            {{customer.approval_status}}
                            </td> -->
                            <td style="min-width: 20px;">
                                {{customer.course_description}}
                            </td>
                            <!-- <td style="min-width: 20px;">
                                {{customer.scheme}} 
                            </td>
                            <td style="min-width: 20px;">
                                {{customer.category}}
                            </td> -->
                            <td style="min-width: 20px;">
                                {{customer.days}} 
                            </td>
                            <td style="min-width: 20px;">
                                {{customer.hours}}
                            </td> 
                            <td><a data-toggle="modal" data-target="#showCM" class="btn btn-primary btn-circle btn-sm"
                                    (click)="buttonviewmeeting(customer,'show')">
                                    <i class="fas fa-flag"></i>
                                </a></td>
                            <td><button data-toggle="modal" data-target="#showCM" [disabled]="customer.status=='cancel'"
                                    class="btn btn-primary btn-circle btn-sm" (click)="buttonviewmeeting(customer,'edit')">
                                    <i class="fas fa-check"></i>
                                </button></td>
                            <td><a class="btn btn-danger btn-circle btn-sm" (click)="delete_CM(customer.id)">
                                <i class="fas fa-times"></i>
                                </a></td>
                            <ng-template #notShow>
                                <a *ngIf="customer.status=='cancel'">
                                    Cancelled

                                </a>
                            </ng-template>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div>

        <div class="modal fade" id="myModal">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <div class="card">
                        <div class="card-header newcolor1">
                            <h3 class="card-title"> Create New Course</h3>
                            <button type="button" class="close" data-dismiss="modal"
                                (click)="Formreset()">&times;</button>
                        </div>

                        <div class="card-body">
                            <form class="register-form" [formGroup]='createmeetingform'
                                (ngSubmit)="postdata(createmeetingform)" autocomplete="off">
                                <div class="form-group row">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Username </label><span class="required "> *</span>
                                        <input pInputText type="text" class="form-control" formControlName="user_name"
                                            [(ngModel)]="user_name" readonly placeholder="Enter Username ">
                                           
                                    </div>

                                </div>
                                <input pInputText type="text" class="form-control" formControlName="user_id"
                                    [(ngModel)]="user_id" readonly placeholder="Enter UserId" style="display:none">
     

                                <div class="row">
                                    <div class="col-sm-12">
                                        <label>Course  <span class="required "> *</span></label>
                                        <input pInputText type="text" class="form-control" formControlName="course_name"
                                            placeholder="Enter Course " required>
                                        <div style="color:red;"
                                            *ngIf="(createmeetingform.get('course_name').touched && createmeetingform.get('course_name').value=='')">
                                            Please fill
                                            the field</div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <label>Course Description<span class="required ">
                                                *</span></label>
                                        <textarea class="form-control" placeholder="Enter Course Description"
                                            formControlName="description" required></textarea>
                                        <div style="color:red;"
                                            *ngIf="createmeetingform.get('description').touched && createmeetingform.get('description').value==''">
                                            Please fill
                                            the field</div>
                                    </div>
                                </div>
                                <!-- <div class="row">
                                    <div class="col-sm-6">
                                        <label>Scheme  <span class="required ">
                                                *</span></label>
                                        <select type="text" class="form-control"
                                            formControlName="scheme"
                                            placeholder="Scheme ">
                                            <option value="" selected>Select Scheme 
                                            </option>
                                            <option>Nan Mudalvam</option>
                                            <option>Anitha</option>
                                        </select>
                                        <div style="color:red;"
                                            *ngIf="(createmeetingform.get('scheme').touched && createmeetingform.get('scheme').value=='')">
                                            Please fill
                                            the field</div>
                                    </div>
              
                                    <div class="col-sm-6">
                                        <label>Category <span class="required ">
                                                *</span></label>
                                        <select class="form-control" 
                                            formControlName="category" required>
                                            <option value="" selected>Select Category
                                            </option>
                                            <option>Civil</option>
                                            <option>Mechanical</option>
                                            <option>Computer</option>
                                            <option>IT</option>

                                                <option>Maths</option>
                                                <option>Physics</option>
                                                <option>Chemistry</option>
                                                <option>Botany</option>
                                                <option>Zoology</option>
                                                <option>Commerce</option>
                                                <option>Accountancy</option>
                                                <option>Economics</option>
                                                <option>History</option>
                                                <option>Civics</option>
                                                <option>Geography</option>
                                                <option>Aptitude</option>
                                                <option>General knowledge</option>
                                                <option>Electrical and Electronics</option>
                                                <option>Electronics and communication</option>
                                                <option>Others</option>
                                            
                                              
                                        </select>
                                        <div style="color:red;"
                                            *ngIf="createmeetingform.get('category').touched && createmeetingform.get('category').value==''">
                                            Please fill
                                            the field</div>
                                    </div>
                                    </div> -->
                                    <div class="row">
                                    <div class="col-sm-6" >
                                        <label>Number of Days<span class="required "> *</span></label>
                                        <input type="text" class="form-control" formControlName="days"
                                            placeholder="Enter Number of Days" required>
                                        <div style="color:red;"
                                            *ngIf="createmeetingform.get('days').touched && createmeetingform.get('days').value === ''">
                                            Please fill
                                            the field</div>
                                    </div>
                                    <div class="col-sm-6">
                                        <label>Number of Hours<span class="required "> *</span></label>
                                        <input type="text" class="form-control" formControlName="hours"
                                            placeholder="Enter Number of Hours" required>
                                        <div style="color:red;" *ngIf="createmeetingform.get('hours').touched && createmeetingform.get('hours').value === ''">
                                            Please fill
                                            the field</div>
                                    </div>
                                    </div>
                                
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label>Status <span class="required "> *</span></label>
                                        <select class="form-control" formControlName="status" required>
                                            <option value="" selected>Select Status</option>
                                            <option value="Active">Active</option>
                                            <option value="Inactive">Inactive</option>

                                        </select>
                                        <div style="color:red;"
                                            *ngIf="createmeetingform.get('status').touched && createmeetingform.get('status').value==''">
                                            Please fill
                                            the field</div>
                                    </div>
                                    <div class="col-md-6">
                                        <label>Course Image</label>
                                        <input type="file" class="form-control" formControlName="image"
                                            (change)="selectFiles($event)" />
                                    </div>
                                </div>
                                <br />


                                <div class="d-flex justify-content-center">
                                    <div style="width:200px">
                                        <button class="btn btn-primary btn-block"
                                            [disabled]="!createmeetingform.valid">Submit</button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>



        <div class="modal fade" id="showCM">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <div class="card-danger">
                        <div class="card-header newcolor1">
                            <h3 class="card-title" id="card_title"></h3>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="card-body">
                          

                            <form class="register-form" [formGroup]='editmeetingform'
                                (ngSubmit)="updatedata(editmeetingform,CM_id)" autocomplete="off">
                                <div >
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Username </label><span class="required "> *</span>
                                        <input pInputText type="text" class="form-control" formControlName="user_name"
                                            placeholder="Enter Username" [value]="CM_name"
                                            readonly="readonly">

                                    </div>
                                    <!-- <input pInputText type="text" class="form-control" formControlName="user_id"
                                        [(ngModel)]="user_id" readonly placeholder="Enter UserId" style="display:none"> -->

                                </div>
                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500">Username <span class="pull-right"> :</span></h6>
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                       CM_name }}</h6>
                                </div>
                            </div></div>
                                <!-- <div class="col-sm-6 mb-3 mb-sm-0">
                                    <label>Username </label><span class="required "> *</span>
                                    <input pInputText type="text" class="form-control" formControlName="user_name"
                                        placeholder="Enter Username" [value]="CM_name"
                                        readonly="readonly">

                                </div> -->
                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row" >
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500">Course <span class="pull-right"> :</span></h6>
                                        <!-- <input pInputText type="text" class="form-control" formControlName="course_name"
                                            [value]="CM_course_name" placeholder="Enter Course " readonly> -->
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                     CM_course_name   }}</h6>
                                </div>
                            </div>
                            <div class="col-6 col-sm-12 col-md-6 row">
                                <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Status <span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 CM_status  }}</h6>
                            </div>
                        </div>
                       
                                </div>

                                <div class="row" *ngIf="editfield">
                                    <div class="col-sm-12">
                                        <label>Course<span class="required "> *</span></label>
                                        <input pInputText type="text" class="form-control" formControlName="course_name"
                                            [value]="CM_course_name" placeholder="Enter Course ">
                                    </div>
                                </div>
    
                                <div class="row" *ngIf="editfield">
                                                                    <div class="col-sm-12">
                                                                        <label>Course Description <span class="required ">
                                                                                *</span></label>
                                                                        <textarea class="form-control" placeholder="Enter Course Description/ தளவரிசை விரித்துரைத்தல்"
                                                                            formControlName="description"  required [value]="CM_course_description"></textarea>
                                                                    </div>
                                </div>
                                <!-- <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row" >
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500">Scheme <span class="pull-right"> :</span></h6>
                                       
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                    CM_scheme   }}</h6>
                                </div>
                            </div>
                            <div class="col-6 col-sm-12 col-md-6 row">
                                <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500"> Category <span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                CM_category   }}</h6>
                            </div></div>
                                </div>
                                -->
      
                                                    <!-- <div class="form-group row" *ngIf="editfield">
                                                        <div class="col-sm-6 mb-3 mb-sm-0">
                                                            <label>Scheme<span class="required ">
                                                                    *</span></label>
                                        <select type="text" class="form-control" formControlName="scheme" placeholder="Scheme / திட்டம்" [(ngModel)]="CM_scheme">
                                            <option value="" selected>Select Scheme
                                            </option>
                                            <option>Nan Mudalvam</option>
                                            <option>Anitha</option>
                                        </select>
                                                    
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Category<span class="required "> *</span></label>
<select class="form-control" formControlName="category" required [(ngModel)]="CM_category">
    <option value="" selected>Select Category
    </option>
    <option>Civil</option>
    <option>Mechanical</option>
    <option>Computer</option>
    <option>Maths</option>
    <option>Physics</option>
    <option>Chemistry</option>
    <option>Botany</option>
    <option>Zoology</option>
    <option>Commerce</option>
    <option>Accountancy</option>
    <option>Economics</option>
    <option>History</option>
    <option>Civics</option>
    <option>Geography</option>
    <option>Aptitude</option>
    <option>General knowledge</option>
    <option>Electrical and Electronics</option>
    <option>Electronics and communication</option>
    <option>Others</option>

</select>
                                                        </div>
                                                    
                                                    </div> -->
                                                    <div class= "row mb-2" *ngIf="!editfield" >
                                                        <div class="col-6 col-sm-12 col-md-6 row" >
                                                            <div class="col-sm-6 col-6" >
                                                            <h6 class="f-w-500">Number of Days <span class="pull-right"> :</span></h6>
                                                           
                                                        </div>
                                                        <div class="col-sm-6 col-6"><h6>{{
                                                       CM_days   }}</h6>
                                                    </div>
                                                </div>
                                                <div class="col-6 col-sm-12 col-md-6 row">
                                                    <div class="col-sm-6 col-6" >
                                                        <h6 class="f-w-500"> Number of Hours <span class="pull-right"> :</span></h6>
                                                       
                                                    </div>
                                                    <div class="col-sm-6 col-6"><h6>{{
                                                     CM_hours  }}</h6>
                                                </div></div>
                                                    </div>
                                                  
                                                    <div class="row" *ngIf="editfield">
                                                        <div class="col-sm-6">
                                                            <label>Number of Days<span class="required "> *</span></label>
                                                            <input type="text" class="form-control" formControlName="days" [value]="CM_days"
                                                                placeholder="Enter Number of Days" required >
                                                    
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <label>Number of Hours<span class="required "> *</span></label>
                                                            <input type="text" class="form-control" formControlName="hours" [value]="CM_hours"
                                                                placeholder="Enter Number of Hours" required >
                                                    
                                                        </div>
                                                    </div>
                                                    <div class= "row mb-2" *ngIf="!editfield" >
                                                        <div class="col-6 col-sm-12 col-md-6 row" >
                                                            <div class="col-sm-6 col-6" >
                                                                <h6 class="f-w-500">Course Description <span class="pull-right"> :</span></h6>
                                                                <!-- <input pInputText type="text" class="form-control" formControlName="course_name"
                                                                    [value]="CM_course_name" placeholder="Enter Course " readonly> -->
                                                            </div>
                                                            <div class="col-sm-6 col-6"><h6>{{
                                                              CM_course_description  }}</h6>
                                                        </div></div>
                                                        <div class="row col-6">
                                                            <div class="col-sm-5 col-5" *ngIf="Course_image !=='' && !editfield">
                                                                <h6 class="f-w-500">Image </h6>
                                                                <img src="https://myroots.redmindtechnologies.com/api/{{Course_image}}"
                                                                    style="width:100px;height:100px;display:block" />
                                
                                                            </div>
                                                        </div>
                                                    </div>

                                <!-- <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Status <span class="required "> *</span></label>
                                        <input pInputText type="text" class="form-control"
                                            formControlName="activity_type" [value]="CM_status"
                                            placeholder="Enter Status" readonly="readonly">

                                    </div>

                                </div> -->

                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Status <span class="required "> *</span></label>
                                        <select class="form-control" formControlName="status" required
                                            [(ngModel)]="CM_status">
                                            <option value="Active">Active</option>
                                            <option value="Inactive">Inactive</option>

                                        </select>

                                    </div>

                                </div>

                                <div class="row">
                                   
                                    <div class="col-md-6" *ngIf="editfield">
                                        <label>Course Image<span class="required">*</span></label>
                                        <input type="file" class="form-control" formControlName="image"
                                            (change)="selectFiles($event)" />
                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0" *ngIf="Course_image !==''&& editfield">
                                        <label>Image <span class="required "> *</span></label>
                                        <img src="https://myroots.redmindtechnologies.com/api/{{Course_image}}"
                                            style="width:100px;height:100px;display:block" />

                                    </div>
                                </div>
<br>
                                <div *ngIf="editfield" class="d-flex justify-content-center">
                                    <div style="width:200px">
                                        <button class="btn btn-primary  btn btn-block">Update</button>
                                    </div>
                                </div>
                            </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>